/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GtmSalesLineEnum {
  DE = 'metro',
  ES = 'makro',
  IT = 'metro',
  PT = 'makro',
  NL = 'makro',
  FR = 'metro'
}
